import React, {PureComponent} from 'react';
import axios from 'axios';
import clone from 'lodash/clone';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import isPlainObject from 'lodash/isPlainObject';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { TextField, InputAdornment, IconButton } from '@material-ui/core/';
import { Col, Row, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

// Comps
import FormSatFirstPage from './FormSatAccess';
import switchMaterial from '../../../components/form/SwitchMaterial';
import NewReactSelectInput from '../../../components/form/NewReactSelectInput';
import LoadingButton from '../../../components/LoadingButton';

// Redux
import regimes from '../../../redux/resources/satRegimenes';
import { connect } from 'react-redux';
import { getIntegrationSat, updateIntegrationSat } from '../../../redux/actions/integrationsActions';
import { promptUser } from '../../../redux/actions/notificationsActions';
import { showNormalNotification } from '../../../redux/actions/notificationsActions';
import { getOnBoarding } from '../../../redux/actions/onBoardingActions';

// Constants
import { SAT_INTEGRATION, SAT_CERTIFICATES } from '../../../constants/endpoints';

// Libs
import { booleanToNumber, setStatePromise, segmentTrackEvent, segmentTrackPageView } from '../../../libs/utils';
import isGood from '../../../libs/isGood';

// Icons
import EyeIcon from 'mdi-react/EyeIcon';
import EyeOffIcon from 'mdi-react/EyeOffIcon';
import HelpCircleIcon from 'mdi-react/HelpCircleIcon';
import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon';
import WarningIcon from 'mdi-react/AlertCircleOutlineIcon';



const renderTextField = ({ input = {}, label, meta: { touched, error }, children, type, InputProps}) => (
  <div className='material-form__field-wrapper'>
    <TextField
      className='material-form__field'
      label={label}
      error={touched && !!error}
      value={input.value}
      children={children}
      type={type}
      variant='outlined'
      onChange={(e) => {
        e.preventDefault();
        input.onChange(e.target.value);
      }}
      InputProps={ InputProps }
      />
    { touched && error && <span className='form__form-group-error'>{ error }</span> }
  </div>
); // END renderTextField

class FormSatIntegration extends PureComponent {
  static propTypes = {
    modal: PropTypes.object,
    initialize: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    promptUser: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    getIntegrationSat: PropTypes.func.isRequired,
    getOnBoarding: PropTypes.func.isRequired,
    formCerts: PropTypes.any,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    sat: PropTypes.object.isRequired,
    form: PropTypes.any,
  } // END propTypes

  state = {
    is_enabled: 0,
    showPassword2: false,
    formPage: 1,
    showConfirmation: false,
    satSuccess: null,
    satError: null,
    isLoadingFirstPage:false,
    isLoadingSecondPage:false,
    regime: null
  } // END state

  componentDidUpdate(prevProps){
    const
      sat     = get(this, 'props.sat', {}),
      prevSat = get(prevProps, 'sat', {});

    if (!isEqual(sat, prevSat)) return this.props.initialize(clone(sat));


  } // END componentDidUpdate

  componentDidMount() {
    segmentTrackPageView('View SAT Integration');
    axios.get(SAT_INTEGRATION)
    .then(res => {
      const data = get(res, 'data.data', {});
      const is_enabled = get(data, 'is_enabled', 0);

      setStatePromise(this, { is_enabled })
        .then(() => {
          if (is_enabled === 1) {
            this.setState({formPage: 2, regime: data.sat_fiscal_regime});
            this.props.initialize({
              'cfdi_download_enabled': data.cfdi_download_enabled,
              'cfdi_enabled': data.cfdi_enabled,
              'cfdi_invoice_folio': get(data, 'cfdi_invoice_current_folio', 1),
              'cfdi_invoice_serie': get(data, 'cfdi_invoice_serie', "F"),
              'cfdi_rep_serie': get(data, 'cfdi_rep_serie', "P"),
              'cfdi_rep_folio': get(data, 'cfdi_rep_current_folio', 1),
              'sat_zip_code': data.sat_zip_code,
              'sat_fiscal_regime': data.sat_fiscal_regime
            })
          } else {
            this.props.initialize({
              'cfdi_download_enabled': 1,
              'cfdi_enabled': 0,
              'cfdi_invoice_folio': 1,
              'cfdi_invoice_serie': "F",
              'cfdi_rep_serie': "P",
              'cfdi_rep_folio': 1
            })
          }
        })
        .catch(error => this.props.dispatch({ type: "ERROR", payload: error }));

    })

  } // END componentDidMount


  /* /////////////// Binded methods /////////////// */

  disable = e => {
    const { modal } = this.props;
    e.preventDefault();
    this.props.promptUser({
      title: '¿Eliminar integración?',
      message: 'Esta acción eliminará la integración actual con el SAT de tu cuenta.',
      color: 'danger'
    })
    .then(confirmation => {
      if (confirmation === 'ok') {
        return axios.delete(SAT_INTEGRATION)
          .then(() => {
            segmentTrackEvent('Disabled SAT Integration', get(this, 'props.account.team.uuid'))
            if (modal) this.selfToggle(1)(confirmation);
            this.props.dispatch(this.props.reset('SAT_INTEGRATION'));
          })
      } else {
        if (modal) modal.toggle(confirmation);
        this.props.dispatch(showNormalNotification({ color: 'warning', message: 'Acción cancelada' }));
      }
    })
    .catch(error => this.props.dispatch({ type: "ERROR", payload: error }));


  } // END disable

  onSubmit = form => {
    const
      { modal}  = this.props,
      { satSuccess } = this.state,
      body = form,
      certsBody = {
        "sat_rfc": get(satSuccess, 'sat_rfc'),
        "sat_legal_name": get(satSuccess, 'sat_legal_name'),
        "sat_private_key_password": get(satSuccess, 'sat_private_key_password'),
        "sat_certificate": get(satSuccess, 'sat_certificate'),
        "sat_private_key": get(satSuccess, 'sat_private_key'),
      },
      newBody = {
        "sat_ciec": body.sat_ciec,
        "cfdi_download_enabled": booleanToNumber(body.cfdi_download_enabled),
        "cfdi_enabled": booleanToNumber(body.cfdi_enabled),
        "sat_zip_code": body.sat_zip_code,
        "sat_fiscal_regime": body.sat_fiscal_regime ? parseFloat(body.sat_fiscal_regime.value) : null,
        "cfdi_invoice_folio": parseFloat(body.cfdi_invoice_folio),
        "cfdi_invoice_serie": body.cfdi_invoice_serie,
        "cfdi_rep_serie": body.cfdi_rep_serie,
        "cfdi_rep_folio": parseFloat(body.cfdi_rep_folio)
      },
      integrate = Object.assign(certsBody, newBody);

    if (get(this, 'state.is_enabled') === 0 && !!satSuccess) {
      this.setState({isLoadingSecondPage:true})
      axios.post(SAT_INTEGRATION, integrate)
        .then(async (res) => {
          this.setState({
            isLoadingSecondPage:false,
          });

          this.props.getIntegrationSat()

          if (modal) {
            this.selfToggle();
          }

          this.props.initialize(get(res, 'data.data'));

          this.setState({
            showConfirmation: false,
          });

          this.props.getOnBoarding()
        })
        .then(() => {
          this.setState({showConfirmation:true, formPage: 2})
        })
        .catch(error => {
          const errorObject = Object.assign({}, error)
          const segmentErrorBody = {
            error_status_code: get(errorObject, 'response.status'),
            error_code       : get(errorObject, 'response.data.code'),
            error_message    : get(errorObject, 'response.data.message')

          }
          segmentTrackEvent('Error On SAT Integration 2', get(this, 'props.account.team.uuid'), segmentErrorBody)
          this.setState({isLoadingSecondPage:false})
          this.props.dispatch({ type: "ERROR", payload: error })
        });

    } else {
      this.setState({isLoadingSecondPage:true})
        axios.put(SAT_INTEGRATION, newBody)
          .then(() => segmentTrackEvent('SAT Integration Update', get(this, 'props.account.team.uuid')))
          .then(() => this.setState({isLoadingSecondPage:false}))
          .then(() => this.props.getIntegrationSat())
          .then(() => modal ? this.selfToggle() : null)
          .catch(error => {
            const errorObject = Object.assign({}, error)
            const segmentErrorBody = {
              error_status_code: get(errorObject, 'response.status'),
              error_code       : get(errorObject, 'response.data.code'),
              error_message    : get(errorObject, 'response.data.message')

            }
            segmentTrackEvent('Error On SAT Integration Update', get(this, 'props.account.team.uuid'), segmentErrorBody)
            this.setState({isLoadingSecondPage:false})
            this.props.dispatch({ type: "ERROR", payload: error })
          });
    } // END if

  } // END onSubmit


  nextPage = formCerts => {
    const
      formData   = new FormData(),
      formValues = Object.keys(this.props.formCerts),
      options    = { headers: { 'content-type': 'multipart/form-data' } };

    formValues.forEach(name => {
      const field = formCerts[name];
      if      (typeof field === 'string')   formData.append(name, field)
      else if (typeof field === 'number')   formData.append(name, field)
      else if (typeof field === 'boolean')  formData.append(name, Number(booleanToNumber(field)))
      else if (Array.isArray(field))        formData.append(name, field[0])
      else if (isPlainObject(field))        formData.append(name, get(field, 'value'));

    }); // END formValues

    this.setState({isLoadingFirstPage:true})
    axios.post(SAT_CERTIFICATES, formData, options)
        .then(res => {
          return setStatePromise(this, {
            satSuccess: res.data.data,
            formPage: this.state.formPage + 1,
            isLoadingFirstPage: false

          });

        })
        .catch(error => {
          const errorObject = Object.assign({}, error)
          const segmentErrorBody = {
            error_status_code: get(errorObject, 'response.status'),
            error_code       : get(errorObject, 'response.data.code'),
            error_message    : get(errorObject, 'response.data.message')

          }
          segmentTrackEvent('Error On SAT Integration 1', get(this, 'props.account.team.uuid'), segmentErrorBody)
          this.setState({
            satError: errorObject.response.data,
            isLoadingFirstPage:false

          });

        }); // END axios.post

  } // END nextPage

  prevPage = () => {
    this.setState({ formPage: this.state.formPage - 1 })

  } // END prevPage

  showPassword2 = (e) => {
    e.preventDefault();
    this.setState({ showPassword2: !this.state.showPassword2});

  } // END showPassword

  selfToggle = () => {
    this.props.modal.toggle();

  } // END selfToggle

  parseError = (satError) => {
    let errorMessage;

    switch (satError) {
      case 102:
        return errorMessage = "Debes llenar todos los campos.";

      case 701:
        return errorMessage = "Error inesperado, comuníquese con soporte.";

      case 702011:
        return errorMessage = "Tu contraseña es inválida.";

      case 702012:
        return errorMessage = "Tus certificados están vencidos.";

      case 702013:
        return errorMessage = "Tus certificados están vencidos.";

      case 702014:
        return errorMessage = "Tus archivos .CER y .KEY no corresponden.";

      case 702015:
        return errorMessage = "Los certificados no corresponden a un CSD.";

      case 702016:
        return errorMessage = "Ya existe un CSD asociado a este RFC";

      case 702020:
        return errorMessage = 'Ocurrió un error con un servicio externo, intentelo más tarde';

      default:
        break;
    }

    return (errorMessage);

  }

  handleRegime = event => this.setState({regime: event})


  /* /////////////// Render /////////////// */
  render() {
    const
      { handleSubmit, submitting, modal, sat, form } = this.props,
      { is_enabled, showConfirmation, formPage, satSuccess, satError, isLoadingFirstPage, isLoadingSecondPage, regime, showPassword2 } = this.state;

    const cfdi_download_enabled = get(form, 'cfdi_download_enabled');
    const cfdi_enabled = get(form, 'cfdi_enabled');

    const btnSatIntegrationClass = classNames({
      'btn-sat-succes-second-page':true,
      'padding-sat-succes-second-page': isLoadingSecondPage
    })

    const btnUpdateSatIntegrationClass = classNames({
      'btn-update-btn-sat-succes-second-page':true,
      'padding-update-sat-succes-second-page':isLoadingSecondPage
    })

    if(showConfirmation === false) {
    return (
      <React.Fragment>
        {formPage === 1 &&
          <FormSatFirstPage parseError={this.parseError} satError={satError} onSubmit={this.nextPage} modal={modal} isLoading={isLoadingFirstPage}/>
        }
        {formPage === 2 &&
          <form className='material-form' onSubmit={ handleSubmit(this.onSubmit) }>
            {is_enabled === 0 &&
              <Row>
                <Col>
                  <h2 className="page-title sat">2 de 2: Permisos</h2>
                  <h5>Descarga tus facturas del SAT de forma automática,
                    comenzaremos a descargar las facturas que generes a partir de la fecha de conexión.</h5>
                </Col>
              </Row>
            }
            {is_enabled === 1 &&
              <Row className="success-integration">
                <Col xs={4}>
                  <p>RFC</p>
                </Col>
                <Col xs={8}>
                  <p>Razón Social</p>
                </Col>
                <Col xs={4}>
                  <span className="rfc-success">{!!sat && sat.sat_rfc}</span>
                </Col>
                <Col xs={6} style={{justifyContent: "flex-start"}}>
                  <span className="rfc-success">{!!sat && sat.sat_legal_name}</span>
                </Col>
                <Col xs={2}>
                  <span className="help-text" onClick={this.prevPage}>Editar</span>
                </Col>
              </Row>
            }
            {is_enabled === 0 &&
              <Row className="success-integration" style={{marginTop:30}}>
                <Col xs={4}>
                  <p>RFC</p>
                </Col>
                <Col xs={8}>
                  <p>Razón Social</p>
                </Col>
                <Col xs={4}>
                  <span className="rfc-success">{satSuccess.sat_rfc}</span>
                </Col>
                <Col xs={8} style={{justifyContent: "flex-start"}}>
                  <span className="rfc-success">{satSuccess.sat_legal_name}</span>
                </Col>
              </Row>
            }
            <Row>
              <Col sm={10} md={10} lg={10} xl={10}>
                <h4 className="inline-title">Descarga de facturas (ciec)</h4>
                {cfdi_download_enabled === 0 ?
                  <span className="toggle-disabled">Desactivada</span>
                : <span className="toggle-disabled">Activada</span>
                }
              </Col>
              <Col className="sat-switch" sm={2} md={2} lg={2} xl={2}>
                <Field
                  component={ switchMaterial }
                  name='cfdi_download_enabled'
                />
              </Col>
              <Col sm={12}>
                <hr style={{marginBottom:20}}/>
              </Col>
              <Col>
                <span style={{marginLeft:270}} className="help-text">
                  <HelpCircleIcon/>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.sat.gob.mx/tramites/38517/generacion-y-actualizacion-de-contrasena-para-persona-fisica">
                  ¿Cómo obtener tu clave CIEC?
                  </a>
                </span>
                <Field
                  name='sat_ciec'
                  component={ renderTextField }
                  type={showPassword2 ? 'text' : 'password'}
                  label='Clave CIEC'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        disablePointerEvents={false}
                        >
                          <IconButton style={{padding:0}} onClick={(e) => {this.showPassword2(e)}}>
                            {showPassword2 ? <EyeOffIcon/> : <EyeIcon/>}
                          </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={10} md={10} lg={10} xl={10}>
                <h4 className="inline-title"style={{marginTop: 15, marginRight: 0}}>Generar timbrado de facturas</h4>
                {cfdi_enabled === 0 || cfdi_enabled === false
                ? <span className="toggle-disabled">Desactivada</span>
                : <span className="toggle-disabled">Activada</span>
                }
              </Col>
              <Col className="sat-switch" sm={2} md={2} lg={2} xl={2}>
                <Field
                  component={ switchMaterial }
                  name='cfdi_enabled'
                />
              </Col>
              <Col sm={12}>
                <hr style={{marginBottom:20}}/>
              </Col>
            </Row>
            {cfdi_enabled === 1 &&
              <React.Fragment>
                <Row>
                  <Col sm={12} md={6} lg={6} xl={6} style={{position:"relative", marginTop:11}}>
                    <Field
                      name='sat_fiscal_regime'
                      component={ NewReactSelectInput }
                      options={ regimes }
                      placeholder='Régimen Fiscal'
                      selectValue={ regime }
                      onChange={this.handleRegime}
                    />
                  </Col>
                  <Col sm={12} md={6} lg={6} xl={6}>
                    <Field
                      name='sat_zip_code'
                      component={ renderTextField }
                      type='text'
                      label='Código postal'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={6} md={6} lg={6} xl={6}>
                      <Field
                        name='cfdi_invoice_serie'
                        component={ renderTextField }
                        type='text'
                        label='Serie de factura'
                      />
                  </Col>
                  <Col sm={6} md={6} lg={6} xl={6}>
                    <Field
                      name='cfdi_invoice_folio'
                      component={ renderTextField }
                      type='text'
                      label='Folio de factura'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={6} md={6} lg={6} xl={6}>
                      <Field
                        name='cfdi_rep_serie'
                        component={ renderTextField }
                        type='text'
                        label='Serie de pagos'
                      />
                  </Col>
                  <Col sm={6} md={6} lg={6} xl={6}>
                      <Field
                        name='cfdi_rep_folio'
                        component={ renderTextField }
                        type='text'
                        label='Folio de pagos'
                      />
                  </Col>
                </Row>
              </React.Fragment>
            }

            {!cfdi_download_enabled && !cfdi_enabled &&
              <Row>
                <Col className="sat__form-group-error">
                  <p><WarningIcon/> Debes habilitar un permiso para integrar con el SAT.</p>
                </Col>
              </Row>
            }

            <Row style={{marginTop:40}} className="modal__form-footer">
              <Col className="align-start">
                {is_enabled === 0 &&
                  <Button style={{padding:'5px 10px'}} color="secondary" onClick={this.prevPage}>Atrás</Button>
                }
                { is_enabled === 1 && <Button
                    color="danger"
                    type='button'
                    style={{padding:'5px 10px'}}
                    className='danger-btn'
                    onClick={ this.disable }
                    disabled={ submitting }>
                    Desconectar
                  </Button>
                }
              </Col>
              <Col className="align-end">
                <Button
                  style={{padding:'5px 10px'}}
                  onClick={()=>this.selfToggle()}
                  color="secondary"
                  className='secondary-btn'>
                  Cancelar
                </Button>
                { formPage === 2 && is_enabled === 0 &&
                  <Button color="success" className={btnSatIntegrationClass}>
                    <LoadingButton isLoading={isLoadingSecondPage} newSize={22} placeholder='Conectar' />
                  </Button>
                }
                { formPage === 2 && is_enabled === 1 &&
                  <Button color="success" className={btnUpdateSatIntegrationClass}>
                    <LoadingButton isLoading={isLoadingSecondPage} newSize={22} placeholder='Actualizar' />
                  </Button>
                }
              </Col>
            </Row>
          </form>
        }
      </React.Fragment>
    ) // END return
    } else {
      return (
        <React.Fragment>
          <div>
            <div className='form__form-group'>
              <div className='form__form-group-login align-icon'>
                <CheckCircleOutlineIcon style={{marginTop: 50}}className="check-icon" />
              </div>
            </div>
            <div className='form__form-group'>
              <div className='form__form-group-login'>
                <p className="succes-mail-message" style={{marginBottom: 50}}>¡Conexión lista!</p>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) //END return
    } // END if
  } // END render
} //END component

const validate = values => {
  const {
      // CIEC
      cfdi_download_enabled,
      sat_ciec,

      // REGIME
      cfdi_enabled,
      sat_zip_code,
      sat_fiscal_regime,
      cfdi_rep_serie,
      cfdi_rep_folio,
      cfdi_invoice_serie,
      cfdi_invoice_folio,


    } = values, errors = {};

  if (!cfdi_rep_serie) errors.cfdi_rep_serie = 'Proporciona serie';
  if (!cfdi_rep_folio) errors.cfdi_rep_folio = 'Proporciona folio';
  if (!cfdi_invoice_serie) errors.cfdi_invoice_serie = 'Proporciona serie de factura';
  if (!cfdi_invoice_folio) errors.cfdi_invoice_folio = 'Proporciona folio de factura';
  if (!!sat_zip_code && !isGood('zip', sat_zip_code)) errors.sat_zip_code = 'Proporciona código postal válido';

  if (cfdi_download_enabled) {
    if (!sat_ciec) errors.sat_ciec = 'Proporciona tu contraseña CIEC';
  }

  if (cfdi_enabled) {
    if (!sat_fiscal_regime) errors.sat_fiscal_regime = 'Selecciona un régimen fiscal';
    if (!sat_zip_code) errors.sat_zip_code = 'Proporciona código postal válido';
  }

  if(!cfdi_enabled && !cfdi_download_enabled) {
    errors.cfdi_download_enabled = 'Debes habilitar un permiso';
    errors.cfdi_enabled = 'Debes habilitar un permiso';
  }

  return errors;

}; // END validate


export default reduxForm({ form: 'SAT_INTEGRATION', validate })(connect(state => ({
  errors             : get(state, 'errors'),
  form               : get(state, 'form.SAT_INTEGRATION.values'),
  formCerts          : get(state, 'form.SAT_CERTS.values'),
  sat                : get(state, 'integrations.sat'),
  integrations       : get(state, 'integrations'),
  enableReinitialize : true,
  account            : get(state, 'account')

}) , { getIntegrationSat, updateIntegrationSat, promptUser, getOnBoarding })(FormSatIntegration)); // END connect export



// WEBPACK FOOTER //
// ./src/containers/account/components/FormSatIntegration.js